import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import ListNumericInput from '../controls/ListNumericInput'
import ListItemMenu from '../controls/ListItemMenu'

const InformacjaUzytkownikaStyle = styled.div`
  .row {
    padding: 12px 12px 12px 20px;
    grid-area: main;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 144px 144px 24px;
    grid-template-areas: 'name from to';
    grid-column-gap: 16px;
    background: white;
    align-items: center;
  }

  .details {
    display: block;
    padding: 0 12px;
  }

  .informacja-row {
    display: grid;
    grid-column-gap: 8px;
    grid-template-columns: 1fr 32px 64px 40px 64px 40px 64px 40px 63px;
    align-items: center;
  }

  .content-header {
    margin: 0;
  }

  .informacja-footer {
    margin-top: 8px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 12px 12px 0;
  }

  .informacja-element {
    margin-bottom: 4px;
  }

  .shortened {
    background: ${props => props.theme.black4};
  }
`

function InformacjaUzytkownika({
  elements,
  zmien,
  usun,
  dodaj,
  czyKwotyWTysiacach,
}) {
  return (
    <InformacjaUzytkownikaStyle>
      <ExpandablePanel
        withoutBackground
        title="POZYCJE USZCZEGÓŁAWIAJĄCE ZAWIERAJĄCE WSKAZANIE PODSTAWY PRAWNEJ"
        multiRow={true}
      >
        {elements.map((x, i) => (
          <div className="informacja-element" key={i}>
            <div className="row">
              <TextField
                placeholder="Nazwa pozycji"
                name="Nazwa"
                title={x.Nazwa}
                value={x.Nazwa}
                onChange={e => zmien(i, e)}
              />
              <ListNumericInput
                placeholder="Rok poprzedni"
                name="KwotaRP"
                value={x.KwotaRP}
                onValueChange={e =>
                  zmien(i, { target: { value: e, name: 'KwotaRP' } })
                }
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
              <ListNumericInput
                placeholder="Rok bieżący"
                name="KwotaRB"
                value={x.KwotaRB}
                onValueChange={e =>
                  zmien(i, { target: { value: e, name: 'KwotaRB' } })
                }
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
              <ListItemMenu
                options={[{ title: 'USUŃ', action: () => usun(i) }]}
              />
            </div>
            <div className="row">
              <div className="informacja-row">
                <span>Podstawa prawna:</span>
                <span>art.</span>
                <TextField
                  placeholder="artykuł"
                  name="Art"
                  title={x.Art}
                  value={x.Art}
                  onChange={e => zmien(i, e)}
                />
                <span>ust.</span>
                <TextField
                  placeholder="ustęp"
                  name="Ust"
                  title={x.Ust}
                  value={x.Ust}
                  onChange={e => zmien(i, e)}
                />
                <span>pkt</span>
                <TextField
                  placeholder="punkt"
                  name="Pkt"
                  title={x.Pkt}
                  value={x.Pkt}
                  onChange={e => zmien(i, e)}
                />
                <span>lit.</span>
                <TextField
                  placeholder="litera"
                  name="Lit"
                  title={x.Lit}
                  value={x.Lit}
                  onChange={e => zmien(i, e)}
                />
              </div>
            </div>
            <div className="content-header">
              <p>W TYM:</p>
            </div>
            <div className="row">
              <span className="high-emphasis-body-1 name">
                - z zysków kapitałowych
              </span>
              <ListNumericInput
                placeholder="Rok poprzedni"
                name="KwotaRP_Kapitalowe"
                value={x.KwotaRP_Kapitalowe}
                onValueChange={e =>
                  zmien(i, {
                    target: { value: e, name: 'KwotaRP_Kapitalowe' },
                  })
                }
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
              <ListNumericInput
                placeholder="Rok bieżący"
                name="KwotaRB_Kapitalowe"
                value={x.KwotaRB_Kapitalowe}
                onValueChange={e =>
                  zmien(i, {
                    target: { value: e, name: 'KwotaRB_Kapitalowe' },
                  })
                }
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
            </div>
            <div className="row">
              <span className="high-emphasis-body-1 name">
                - z innych źródeł przychodów
              </span>
              <ListNumericInput
                placeholder="Rok poprzedni"
                name="KwotaRP_Inne"
                value={x.KwotaRP_Inne}
                onValueChange={e =>
                  zmien(i, { target: { value: e, name: 'KwotaRP_Inne' } })
                }
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
              <ListNumericInput
                placeholder="Rok bieżący"
                name="KwotaRB_Inne"
                value={x.KwotaRB_Inne}
                onValueChange={e =>
                  zmien(i, { target: { value: e, name: 'KwotaRB_Inne' } })
                }
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
            </div>
          </div>
        ))}
        <div className="informacja-footer">
          <Button
            className="lastButton"
            onClick={() => dodaj()}
            color="primary"
            variant="outlined"
          >
            DODAJ POZYCJĘ USZCZEGÓŁAWIAJĄCĄ
          </Button>
        </div>
      </ExpandablePanel>
    </InformacjaUzytkownikaStyle>
  )
}

export default InformacjaUzytkownika
